import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';



@Component({
  selector: 'app-share-sheet',
  templateUrl: './share-sheet.component.html',
  styleUrls: ['./share-sheet.component.scss']
})
export class ShareSheetComponent {
  constructor(
    public ref: MatDialogRef<ShareSheetComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { url: string; text: string; title: string },
    private snack: MatSnackBar
  ) {}

  open(target: 'whatsapp'|'telegram'|'facebook'|'twitter'|'email') {
    const u = encodeURIComponent(this.data.url);
    const t = encodeURIComponent(this.data.text);

    const map = {
      whatsapp: `https://wa.me/?text=${t}%20${u}`,
      telegram: `https://t.me/share/url?url=${u}&text=${t}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
      twitter:  `https://twitter.com/intent/tweet?url=${u}&text=${t}`,
      email:    `mailto:?subject=${encodeURIComponent(this.data.title)}&body=${t}%0A%0A${u}`
    } as const;

    window.open(map[target], '_blank', 'noopener,noreferrer');
    this.ref.close();
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.data.url);
      this.ref.close({ copied: true });
    } catch {}
  }

  onCopied(success: boolean) {
    this.snack.open(success ? 'Link copied!' : 'Failed to copy. Tap & hold to select.', undefined, { duration: 2000 });
    if (success) this.ref.close({ copied: true });
  }
}